import { jsx as o } from "react/jsx-runtime";
import { useRef as r } from "react";
import { renderToString as n } from "react-dom/server";
import { UtilityChevronIcon as t } from "./index.es439.js";
const p = () => {
  const s = r(n(/* @__PURE__ */ o(t, { direction: "down" }))), m = r(n(/* @__PURE__ */ o(t, { direction: "down" })));
  return {
    smallDown: () => s.current,
    smallUp: () => m.current
  };
};
export {
  p as useCustomIcons
};
//# sourceMappingURL=index.es600.js.map
